import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { AuditEventPageDto, AuditFilter, AuditService } from '../audit.service';
import { AuditEventDto } from '../models/audit.model';
import { MockDataLoader } from './mock-data-loader.service';

interface AuditFixture { items: AuditEventDto[] }

@Injectable()
export class AuditMockService extends AuditService {
  private readonly mockData = inject(MockDataLoader);
  private readonly events = new BehaviorSubject<AuditEventDto[]>([]);
  private loaded = false;
  private loading = false;

  getEvents(filter?: AuditFilter): Observable<AuditEventPageDto> {
    this.ensureLoaded();
    return this.events.pipe(map(items => ({ items: this.applyFilter(items, filter) })));
  }

  override addEvent(event: Partial<AuditEventDto> & Pick<AuditEventDto, 'eventType' | 'entityType' | 'entityId'>): void {
    const item: AuditEventDto = {
      ...event,
      eventId: event.eventId ?? `AUD-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
      eventType: event.eventType,
      entityType: event.entityType,
      entityId: event.entityId,
      userId: event.userId ?? 'USR-MOCK',
      userName: event.userName ?? 'Utilisateur mock',
      eventDate: event.eventDate ?? new Date().toISOString(),
      description: event.description ?? event.eventType,
    };
    this.events.next([item, ...this.events.value]);
  }

  private ensureLoaded(): void {
    if (this.loaded || this.loading) return;
    this.loading = true;
    this.mockData.load<AuditFixture>('audit-events').subscribe({
      next: fixture => {
        this.events.next([...this.events.value, ...fixture.items]);
        this.loaded = true;
        this.loading = false;
      },
      error: () => { this.loaded = true; this.loading = false; },
    });
  }

  private applyFilter(items: AuditEventDto[], filter?: AuditFilter): AuditEventDto[] {
    return items
      .filter(e => !filter?.entityType || e.entityType === filter.entityType)
      .filter(e => !filter?.entityId || e.entityId === filter.entityId)
      .filter(e => !filter?.userId || e.userId === filter.userId)
      .filter(e => !filter?.dateFrom || e.eventDate.slice(0, 10) >= filter.dateFrom)
      .filter(e => !filter?.dateTo || e.eventDate.slice(0, 10) <= filter.dateTo);
  }
}
